import API from './api';

export const getAuthUser = () => {
  const user = localStorage.getItem('auth');
  try {
    return user ? JSON.parse(user) : null;
  } catch (e) {
    console.error('Gagal parse data user dari localStorage:', e);
    return null;
  }
};

export const setAuthToken = (token) => {
  localStorage.setItem('token', token);
};

export const clearAuthToken = () => {
  localStorage.removeItem('token');
};

export const clearAuthUser = () => {
  localStorage.removeItem('auth');
};

export const login = async (email, password) => {
  const response = await API.post('/login', { email, password });
  const token = response.data.access_token;
  setAuthToken(token);

  const userRes = await API.get('/me');
  localStorage.setItem('auth', JSON.stringify(userRes.data));

  return userRes.data;
};

export const logout = async () => {
  try {
    await API.post('/logout');
  } catch (error) {
    console.warn("Logout gagal atau sudah expired:", error);
  }
  clearAuthToken();
  clearAuthUser();
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};
